import React from "react";
import ContentLoader from "react-content-loader";
import PropTypes from "prop-types";

import "./style.scss";

const ShimmerMultiLine = ({ count, ...rest }) => {
  const classNames = ["placeholder", count > 1 ? "text-vgap16" : ""].filter(name => name).join(" ");

  return (
    <>
      {Array.from(Array(count)).map((item, index) => (
        <ContentLoader
          key={index}
          speed={2}
          width="100%"
          viewBox="0 0 340 84"
          backgroundColor="#d6d6d6"
          foregroundColor="#ededed"
          className={classNames}
          {...rest}
        >
          <rect x="0" y="0" rx="3" ry="3" width="67" height="11" />
          <rect x="76" y="0" rx="3" ry="3" width="140" height="11" />
          <rect x="127" y="48" rx="3" ry="3" width="53" height="11" />
          <rect x="187" y="48" rx="3" ry="3" width="72" height="11" />
          <rect x="18" y="48" rx="3" ry="3" width="100" height="11" />
          <rect x="0" y="71" rx="3" ry="3" width="37" height="11" />
          <rect x="18" y="23" rx="3" ry="3" width="140" height="11" />
          <rect x="166" y="23" rx="3" ry="3" width="173" height="11" />
        </ContentLoader>
      ))}
    </>
  );
};

ShimmerMultiLine.propTypes = {
  count: PropTypes.number,
};

ShimmerMultiLine.defaultProps = {
  count: 1,
};

export default ShimmerMultiLine;
